import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register PWA service worker (skip on local dev refresh issues)
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {
      /* noop */
    });
  });

  // iter247c (2026-08-22) — Auto-reload once when a new Service Worker
  // takes control of this page. Without this, the SW upgrade activates
  // in the background but the currently-open tab keeps running the
  // OLD JS bundle until the user manually hard-refreshes. That's what
  // caused the Admin Dashboard to keep showing "0 pending" on
  // production even after the sw.js version bump shipped.
  //
  // The `reloadedOnceRef` guard prevents an infinite reload loop if
  // multiple `controllerchange` events fire.
  let reloadedOnce = false;
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (reloadedOnce) return;
    reloadedOnce = true;
    window.location.reload();
  });
}
